import React, { Component } from 'react'

export default class Loader extends Component {

    render() {
        let showClass = this.props.show ? 'show-inherit' : 'hide';
        let square = this.props.square != null ;
        return (
            <div className={`${this.props.classes} container-centered` }>
                {
                    square ? <div className="sk-folding-cube"><div className="sk-cube1 sk-cube"/><div className="sk-cube2 sk-cube"/><div className="sk-cube4 sk-cube"/><div className="sk-cube3 sk-cube"/></div>
                        : <div className="loading-spinner"/>
                }
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/elements/loader/Loader.jsx